<template>
  <Modal
    v-model="shows"
    :title="$t('village.index.527052-0')"
    class-name="vertical-center-modal"
    :ok-text="$t('village.index.527052-1')"
    width="330"
    height="600"
    :z-index="1001"
    @on-ok="submit"
    @on-cancel="shows = false"
  >
    <Tree :data="areaList" :load-data="loadData" @on-select-change="onSelectChange"></Tree>
  </Modal>
</template>

<script>
import api from "../../../../../../api/request.js";
import Cookies from "js-cookie";
const URL = {
  GetCommunitylist: "api/User/GetCommunitylist", // 城市列表
  GetVillagelist: "api/User/GetVillagelist", // 区域列表
  GetSVillageList: "api/User/GetSVillageList", // 乡镇列表
  GetZVillageList: 'api/User/GetZVillageList', // 村列表
};

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      areaList: [{
        title: this.$t('village.index.527052-2'),
        loading: false,
        disabled: true,
        children: [],
        grade: 0
      }]
    };
  },
  computed: {
    shows: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      }
    }
  },
  mounted() {
      this.GetRoshCommunityList();
  },
  methods: {
    // 加载城市列表
    GetRoshCommunityList() {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetCommunitylist}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          this.areaList[0].children = (res.Data || []).map(item => {
            return {
              title: item.Cname,
              loading: false,
              children: [],
              grade: 1,
              ...item
            };
          });
        }
      });
    },
    // 区域
    GetVillagelist(item, callback) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetVillagelist}?Ccode=${item.Ccode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          const data = (res.Data || []).map(item => {
            return {
              title: item.Vname,
              loading: false,
              children: [],
              grade: 2,
              ...item
            };
          });
          if (data.length) {
            callback(data);
          } else {
            callback([{
              title: this.$t('village.index.527052-3'),
              disabled: true
            }]);
          }
        }
      });
    },
    // 乡镇
    GetSVillageList(item, callback) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetSVillageList}?Vcode=${item.Vcode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          const data = (res.Data || []).map(item => {
            return {
              title: item.Sname,
              loading: false,
              children: [],
              grade: 3,
              ...item
            };
          });
          if (data.length) {
            callback(data);
          } else {
            callback([{
              title: this.$t('village.index.527052-3'),
              disabled: true
            }]);
          }
        }
      });
    },
    // 村
    GetZVillageList(item, callback) {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "get",
        url: `${URL.GetZVillageList}?Scode=${item.Scode}`,
        data: {},
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token")
        }
      }).then(res => {
        if (res.Success) {
          const data = (res.Data || []).map(item => {
            return {
              title: item.Zname,
              grade: 4,
              ...item
            };
          });
          if (data.length) {
            callback(data);
          } else {
            callback([{
              title: this.$t('village.index.527052-3'),
              disabled: true
            }]);
          }
        }
      });
    },
    // 加载更多
    loadData(item, callback) {
        switch (item.grade) {
            case 1:
                this.GetVillagelist(item, callback);
                break;
            case 2: 
                this.GetSVillageList(item, callback)
                break;
            case 3: 
                this.GetZVillageList(item, callback)
                break;
            default:
                break;
        }
    },
    // 点击节点触发
    onSelectChange(item) {
        this.shows = false;
        if (item.length) {
            this.$emit("on-change", {...item[0]})
        }
    },
    submit() {
      this.shows = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/useGas/views/user/mods/village/index.vue